.content {
  position: absolute;
  top: 18em;
  left: calc(100% + 0.25em);
  padding: 0;
  z-index: 1;
  margin-top: 0 !important;
}
